import React, { useCallback } from 'react';
import { NavLink, type NavLinkProps, useNavigate } from 'react-router';

export const ADMIN_LINK_PREFIX = '/ops';

export const useNavigateA = () => {
    const navigate = useNavigate();

    const navigateA = useCallback(
        (link: string) => {
            return navigate(ADMIN_LINK_PREFIX + link);
        },
        [navigate]
    );

    return navigateA;
};

export function LinkA(props: React.PropsWithoutRef<NavLinkProps> & React.RefAttributes<HTMLAnchorElement>) {
    const { to, ...otherProps } = props;
    const toA = ADMIN_LINK_PREFIX + to;
    return <NavLink end to={toA} {...otherProps} />;
}
